import React, { useState, useContext } from 'react';

import styles from './CookiePrivacy.module.scss';
import { Text } from 'components/Text';
import { StoreContext } from 'store';

const LOCAL_STORAGE_KEY = 'cookiePrivacyState';
const ACCEPTED = 'accepted';

export const CookiePrivacy = () => {
  const { translation: t } = useContext(StoreContext);

  const [isVisible, setIsVisible] = useState(() => {
    const cooliePrivacy = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (cooliePrivacy === ACCEPTED) {
      return false;
    }
    return true;
  });

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Text.ParagraphL className={styles.message}>
        {t.cookiePolicy.message}{' '}
        <a target="_blank" rel="noreferrer" href="https://tacticool.game/cookies">
          {t.cookiePolicy.link}
        </a>
      </Text.ParagraphL>
      <button
        onClick={() => {
          localStorage.setItem(LOCAL_STORAGE_KEY, ACCEPTED);
          setIsVisible(false);
        }}
        className={styles.button}
      >
        {t.cookiePolicy.accept}
      </button>
    </div>
  );
};
